// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_RESSOURCES } from "api/services/teacher/teacher.routes";

// Define a service using a base URL and expected endpoints
export const adsApi = createApi({
  reducerPath: "adsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_RESSOURCES,
    prepareHeaders: (headers) => {
      headers.set("Cache-Control", "no-cache");
      return headers;
    },
  }),
  tagTypes: ["ADS", "ADS_SPECIFIC"],

  endpoints: (builder) => ({

    createAd: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/advertisements`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["ADS"],
    }),

    upadateAd: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/advertisements/${body?.calendarId}`,
          method: "PATCH",
          body: body?.updateData,
        };
      },
      invalidatesTags: ["ADS"],
    }),

    upCreSpec: builder.mutation<any, any>({
      query: (body) => {
        const final = {
          teacherId: body?.teacherId,
          niches: [...body?.niches],
        };

        return {
          url: `/advertisements/${body?.idCreneau}/user/creneauSpecific/updateOne`,
          method: "PATCH",
          body: {
            ...final,
          },
        };
      },
      invalidatesTags: ["ADS"],
    }),

    createAdSpecific: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/advertisements/user/creneauSpecific/create`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["ADS_SPECIFIC"],
    }),

    deleteTeacherAdSpecific: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/advertisements/user/creneauDel/instance/create`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["ADS_SPECIFIC"],
    }),

    deleteAdSpecific: builder.mutation<any, string>({
      query: (idCreneau) => {
        return {
          url: `/advertisements/${idCreneau}/user/creneauSpecific/deleteOne`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["ADS_SPECIFIC"],
    }),

    updateAd: builder.mutation<any, any>({
      query: ({ idAd, body }) => {
        return {
          url: `/advertisements/${idAd}`,
          method: "PATCH",
          body: body,
        };
      },
      invalidatesTags: ["ADS"],
    }),

    deleteAd: builder.mutation<any, string>({
      query: (idAd) => {
        return {
          url: `/advertisements/${idAd}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["ADS"],
    }),

    getCalendarTeacher: builder.query<any, string>({
      query: (idTeacher) => {
        const token = localStorage.getItem("tokenFirebase");
        return {
          url: `/advertisements/fetch/ReelCalender/${idTeacher}`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      providesTags: ["ADS"],
    }),

    getAdHistorique: builder.query<any, string>({
      query: (profId) => {
        return {
          url: `/advertisements/fetch/Reservations/historique?profId=${profId}`,
        };
      },
      providesTags: ["ADS"],
    }),

    getAd: builder.query<any, string>({
      query: (idAd) => {
        return {
          url: `/advertisements/?teacherId=${idAd}`,
        };
      },
      providesTags: ["ADS"],
    }),

    getAllAdSpecific: builder.query<any, string>({
      query: (idTeacher) => {
        return {
          url: `/advertisements/user/creneauSpecific/find?teacherId=${idTeacher}`,
        };
      },
      providesTags: ["ADS_SPECIFIC"],
    }),

    updateAdSpecific: builder.mutation<any, any>({
      query: (body) => {
        return {
          url: `/advertisements/user/creneauSpecific/replanifier`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["ADS_SPECIFIC"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useUpdateAdMutation,
  useGetAdQuery,
  useGetCalendarTeacherQuery,
  useDeleteAdMutation,
  useCreateAdMutation,
  useCreateAdSpecificMutation,
  useGetAllAdSpecificQuery,
  useUpadateAdMutation,
  useUpCreSpecMutation,
  useDeleteAdSpecificMutation,
  useDeleteTeacherAdSpecificMutation,
  useGetAdHistoriqueQuery,
  useUpdateAdSpecificMutation,
} = adsApi;
